export enum UserGeneralInfoContextKeys {
  VIEW_LEGACY = "viewLegacy",
  USER_ID = "userId",
  HEALTHCARE_FACILITY_ID = "healthcareFacilityId",
  INTERNAL_ORGANIZATION_FACILITY_ID = "internalOrganizationFacilityId",
  ORG_NAME = "orgName",
  PARENT_TABLE = "parentTable",
  BO_COMMENTS = "boComments",
  JCODE_DOCS = "jCodeDocs",
  GLOBAL_BO_VALUE = "globalBoValue",
  AUTH_STATUS_CHANGE_COMMENTS = "authStatusChangeComments",
  CPT_CODES = "cptCodes",
  J_CODES = "jCodes",
  EXISTING_JCODE_DOCS = "existingJCodeDocs",
  MEDICINE_NAMES = "medicineNames",
  INDEX_TAB = "indexTab",
  PAYER_NAME = "payerName",
  ENABLE_REVIEW_MODE = "enableReviewMode",
  // PROVIDER_NAME = "providerName",
}
